const INLINE_TOOLBAR_WIDTH = 302;
const INLINE_TOOLBAR_HEIGHT = 50;
const GAP_SIZE = 5;
export const ADJUSTMENT_OFFSET = 40;

export const getSelectionRange = selection => {
  if (selection.rangeCount === 0) {
    return null;
  }
  return selection.getRangeAt(0);
};

export const getInlineToolbarPosition = (selectionRange, editorElement) => {
  const editorRect = editorElement.getBoundingClientRect();
  const rangeRect = selectionRange.getBoundingClientRect();
  const rangeWidth = rangeRect.right - rangeRect.left;

  const left = rangeRect.left - editorRect.left + rangeWidth / 2 - INLINE_TOOLBAR_WIDTH / 2 + ADJUSTMENT_OFFSET;
  const top = rangeRect.top - editorRect.top - INLINE_TOOLBAR_HEIGHT - GAP_SIZE;

  return { left, top };
};



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/text-selection-utils.js